<template>
    <div class="container">
        <slot></slot>
    </div>
</template>

<script>
</script>

<style lang="scss">
@use "./index.scss";
</style>
